// 是否在当前路由
export interface MenuItem {
    name: string;
    routeName: string;
    icon: string;
    tips?: string;
    showChildren?: boolean;
    children?: Array<MenuItem>;
}
// 深度优先遍历
const BFS = function(item: MenuItem) {
    let list: Array<string> = [];
    let queue: Array<MenuItem> = [];
    list.push(item.routeName);
    queue.push(item);
    while (queue.length) {
        let node: any = queue.pop();
        if (node.children) {
            node.children.forEach((menu: MenuItem) => {
                list.push(menu.routeName);
                queue.push(menu);
            });
        }
    }
    return list;
};

const hasOwnMenu = function(item: MenuItem, currentRouteName: any) {
    if (!currentRouteName) {
        return false;
    }
    if (item.routeName === currentRouteName) {
        return true;
    }
    if (item.children && item.children.length) {
        let menuList: any = BFS(item);
        if (menuList.indexOf(currentRouteName) > -1) {
            return true;
        }
    }
    return false;
};
export { hasOwnMenu };
